import React, { useState, useRef, useEffect } from "react";
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import { Link } from "gatsby";
import { InView } from 'react-intersection-observer';
import scrollTo from 'gatsby-plugin-smoothscroll';
import IconArrowBottom from "../../icons/icon-scroll-down.svg";
//import HeaderAnim from '../common/utils/animations/textRevealAnimation';
import { Link as LinkScroll } from 'react-scroll';

export default function HomePageMainBanner(props) {
  const { classes, header, content, position, bottomGap, link, scrollSection, buttonText, mediaSource, mediaPoster, mediaClass, imageSource } = props.data;
  const ref = useRef();
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 100;
  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const setValues = () => {
      setElementTop(ref.current.offsetTop);
      setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
      setClientHeight(window.innerHeight);
      setisMobile(window.innerWidth <= 1023);
    };
    setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  }, [ref]);

  const opacity = useTransform(scrollY, [elementBottom, elementTop], [0, 1], "anticipate");

  return (
    <InView onChange={(inView) => { props.setShowVerticleNav && (inView && props.setShowVerticleNav(false)); }}>
      <div ref={ref} className={`video-banner common-page-banner-section d-flex flex-wrap align-v-center ${classes} ${bottomGap}`}>
        <motion.div style={{ opacity }} className="full-width-media">
          {!isMobile && <>
            {mediaSource != "" &&
                <video className={mediaClass} autoPlay muted preload="auto" playsInline loop poster={mediaPoster}>
                  <source src={mediaSource} type="video/mp4" />
                </video>
            }
          </>}
          {isMobile && <>
            <img className="poster-image" src={mediaPoster} alt="Mission" />
          </>}
          {imageSource != "" &&
            <img src={imageSource} alt="Mission" />
          }

        </motion.div>
        <div className="container">
          <div className={position === 'center' ? `d-flex text-center justify-center` : ``}>
            <div className="page-banner-detail">
              {/*<h1><HeaderAnim header={header} /></h1>*/}
              <h1>{header}</h1>
              {content}
              {
                classes.includes('career') ?
                  <div className='button button-white-border right-arrow' onClick={() => { scrollTo(`#${link}`); }}>{buttonText}</div> :
                  <div><Link to='/services/' className='button button-white-border right-arrow'>{buttonText}</Link></div>
              }
            </div>
          </div>
        </div>
        <div className="scroll-more">
          <div className="scroll-more-inner">
            <LinkScroll to={scrollSection} smooth={true} duration={700} ><div className="icon-scroll-more"><IconArrowBottom /></div></LinkScroll>
            <span>Scroll More</span>
          </div>
        </div>
      </div>
    </InView>
  );
}



